import React from "react"
import { useTranslation } from "react-i18next"

import { ObligationList } from "~/api/types/ObligationList"
import { Attachment } from "~/components/Attachment/Attachment"
import { Heading } from "~/components/Heading/Heading"
import { PopupWrapper } from "~/components/Popup/Popup"
import { Raw } from "~/components/raw"
import { formatDateNew } from "~/helpers/formatDate"

import { Item } from "../Item/Item"
import styles from "./index.module.css"

const Content: React.FC<ObligationList> = ({
  countryOfIssue,
  coupon,
  dateOfAdmission,
  dateOfTheNextOffer,
  file,
  issueVolume,
  redemptionDate,
  stateRegNumber,
  summuryId,
}) => {
  const { t } = useTranslation()

  return (
    <div className={styles.Wrapper}>
      <div>
        <Heading className={styles.Title} like="h3">
          <Raw html={stateRegNumber} />
        </Heading>

        <div dangerouslySetInnerHTML={{ __html: t("obligation.Item.Title") }} />
      </div>

      <div className={styles.List}>
        <div>
          <Heading className={styles.Name} like="h4">
            <Raw html={coupon} />
            &nbsp; %
          </Heading>
          <div dangerouslySetInnerHTML={{ __html: t("obligation.Item.Coupon") }} />
        </div>

        <div>
          <Heading className={styles.Name} like="h4">
            <Raw html={countryOfIssue} />
          </Heading>
          <div dangerouslySetInnerHTML={{ __html: t("obligation.Item.CountryOfIssue") }} />
        </div>

        <div>
          <Heading className={styles.Name} like="h4">
            <Raw html={issueVolume} />
          </Heading>
          <div dangerouslySetInnerHTML={{ __html: t("obligation.Item.IssueVolume") }} />
        </div>

        <div>
          <Heading className={styles.Name} like="h4">
            {formatDateNew(dateOfAdmission, "dd.MM.yyyy")}
          </Heading>
          <div dangerouslySetInnerHTML={{ __html: t("obligation.Item.DateOfAdmission") }} />
        </div>

        <div>
          <Heading className={styles.Name} like="h4">
            {formatDateNew(dateOfTheNextOffer, "dd.MM.yyyy")}
          </Heading>
          {dateOfTheNextOffer && (
            <div dangerouslySetInnerHTML={{ __html: t("obligation.Item.DateOfTheNextOffer") }} />
          )}
        </div>

        <div>
          <Heading className={styles.Name} like="h4">
            {formatDateNew(redemptionDate, "dd.MM.yyyy")}
          </Heading>
          <div dangerouslySetInnerHTML={{ __html: t("obligation.Item.RedemptionDate") }} />
        </div>
      </div>

      <div>
        <Heading className={styles.Name} like="h4">
          <Raw html={summuryId} />
        </Heading>
        <div dangerouslySetInnerHTML={{ __html: t("obligation.Item.SummuryId") }} />
      </div>

      {file.link !== null && <Attachment {...file} />}
    </div>
  )
}

export const PopupItem: React.FC<ObligationList & { className?: string }> = ({
  className,
  ...item
}) => (
  <PopupWrapper
    button={
      <div className={className}>
        <Item {...item} />
      </div>
    }
    content={() => <Content {...item} />}
  />
)
